import axios from "axios";
import { useState, useContext, useEffect } from "react";
import { url } from "../utils/url";
import { useHistory } from "react-router-dom";
import Logged from "./Profile.jsx";
import TryLogin from "./TryLogin";
import UserContext from "../UserContext";
import { LoadingOutlined } from "@ant-design/icons";
import SidebarNav from "./navigation/SidebarNav";
const CreatePost = () => {
  const { user, reloadRequests, mode, prependPost } = useContext(UserContext);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [tabs, switchTabs] = useState("twik");
  const [gradient, setGradient] = useState();
  // const [title, settitle] = useState();
  const [content, setcontent] = useState();
  // const handletitle = (e) => {
  //   settitle(e.target.value);
  // };

  // upload image here

  const [file, setFile] = useState("");
  const [img, setImage] = useState("");
  let tempFile;

  const uploadImage = (e) => {
    tempFile = e.target.files[0];
    // console.log("img",tempFile)
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      function () {
        setFile(reader.result);
        setImage(tempFile);
      },
      false
    );

    if (tempFile) {
      reader.readAsDataURL(tempFile);
    }
    // setFilename(e.target.files.name);
  };

  const handlecontent = (e) => {
    setcontent(e.target.value);
  };

  async function handleSubmit(e) {
    setLoading(true);
    e.preventDefault();

    const formData = new FormData();
    formData.append("file", img);
    try {
      let type = tabs === "twik" ? "TWIK" : "ANONYTWIK";

      const postResponse = await axios.post(
        `${url}/api/posts/addpost`,
        {
          title: "🔥",
          content,
          gradient,
          type,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      if (img) {
        const imgResponse = await axios.post(
          `${url}/api/posts/upload-image/${postResponse.data.data.id}?action=post`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        if (imgResponse) {
          window.Toast.fire({
            icon: "success",
            title: "Post created!",
          });
          if (postResponse.data.data) prependPost(postResponse.data.data);
          reloadRequests();
          history.push("/");
        }
      } else {
        if (postResponse.data.success) {
          window.Toast.fire({
            icon: "success",
            title: "Post created!",
          });
          prependPost(postResponse.data.data);
          reloadRequests();
          history.push("/");
        }
      }
    } catch (err) {
      window.displayToastError("Operation failed.");
      setLoading(false);
    }
    setLoading(false);
  }

  // setting the theme
  const [dark, setDark] = useState(false);
  const [activeFileTab, setActiveFileTab] = useState("picture");

  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  return (
    <div className="flex justify-center w-full">
      <div className="px-2 grid grid-cols-1 lg:grid-cols-11 lg:w-3/4 lg:gap-10">
      <div className="lg:col-span-6 lg:grid grid-cols-7">
            <div className="top-0 sticky col-span-1 lg:h-screen">
              <div className="hidden lg:block">
              <SidebarNav />
              </div>
            </div>
            <div className="col-span-6">
          <form className="w-full " onSubmit={handleSubmit}>
            <h1 className="text-sm font-bold mt-5 mb-3">
              {" "}
              Reveal your Twiks 🔥
            </h1>

            {/* <div className="form-group">
              <label htmlFor="title">Title</label>
              <input
                type="text"
                className="form-control"
                id="title"
                value={title}
                onChange={handletitle}
                placeholder=""
                required
              />
            </div> */}

            {/* content */}
            <div className="form-group">
              <label htmlFor="content">
                {tabs === "twik"
                  ? "Twik Caption"
                  : "Twik Anony (Question, Statement,...)"}
              </label>
              <textarea
                className={`form-control ${
                  gradient && gradient + " text-white text-center font-bold"
                }`}
                id="content"
                rows="5"
                value={content}
                onChange={handlecontent}
                placeholder=""
                required
              />
            </div>
            {/* tabs */}

            <div className="flex gap-2 my-4 cursor-pointer">
              <div className="flex gap-2 items-center">
                <span
                  className={`${
                    tabs === "twik" ? "bg-fire" : "border"
                  } w-4 h-4 rounded-full  p-1`}
                  onClick={() => switchTabs("twik")}
                ></span>
                <span onClick={() => switchTabs("twik")}>Twik</span>
              </div>
              <div className="flex gap-2 items-center">
                <span
                  className={`${
                    tabs === "anony" ? "bg-fire" : "border"
                  } w-4 h-4 rounded-full  p-1`}
                  onClick={() => switchTabs("anony")}
                >
                  {" "}
                </span>
                <span onClick={() => switchTabs("anony")}>Twik Anony</span>
              </div>
            </div>

            {/* twik anony feature */}
            {/* {tabs === "anony" && ( */}
              <div className="my-2">
                <h1 className="text-sm my-3">Choose gradient {tabs !== "anony"?<span
                className="text-xs  font-mono italic hover:text-white hommy--btn rounded px-2 py-1 mr-3 hover:opacity-80 no-underline"
                >Only for a twik with no pic</span>:''} </h1>
                <div className="w-full flex justify-between mb-10 cursor-pointer">
                  <div
                    className={`bg-gradient-1 w-10 h-10 p-1 hover:shadow-lg ${
                      gradient === "bg-gradient-1"
                        ? "rounded-full shadow-lg"
                        : "rounded"
                    }`}
                    onClick={() => setGradient("bg-gradient-1")}
                  ></div>
                  <div
                    className={`bg-gradient-2 w-10 h-10 p-1 hover:shadow-lg ${
                      gradient === "bg-gradient-2"
                        ? "rounded-full shadow-lg"
                        : "rounded"
                    }`}
                    onClick={() => setGradient("bg-gradient-2")}
                  ></div>
                  <div
                    className={`bg-gradient-3 w-10 h-10 p-1 hover:shadow-lg ${
                      gradient === "bg-gradient-3"
                        ? "rounded-full shadow-lg"
                        : "rounded"
                    }`}
                    onClick={() => setGradient("bg-gradient-3")}
                  ></div>
                  <div
                    className={`bg-gradient-4 w-10 h-10 p-1 hover:shadow-lg ${
                      gradient === "bg-gradient-4"
                        ? "rounded-full shadow-lg"
                        : "rounded"
                    }`}
                    onClick={() => setGradient("bg-gradient-4")}
                  ></div>
                  <div
                    className={`bg-gradient-5 w-10 h-10 p-1 hover:shadow-lg ${
                      gradient === "bg-gradient-5"
                        ? "rounded-full shadow-lg"
                        : "rounded"
                    }`}
                    onClick={() => setGradient("bg-gradient-5")}
                  ></div>
                  <div
                    className={`bg-gradient-6 w-10 h-10 p-1 hover:shadow-lg ${
                      gradient === "bg-gradient-6"
                        ? "rounded-full shadow-lg"
                        : "rounded"
                    }`}
                    onClick={() => setGradient("bg-gradient-6")}
                  ></div>
                </div>
              </div>
            {/* )} */}

            {/* twik anony ends here */}

            {/* files uploading */}

            {tabs === "twik" && (
              <>
                {/* image */}
                <div className="form-group">
                  <div className="flex gap-5">
                    <label
                      htmlFor=""
                      className={
                        activeFileTab === "picture"
                          ? `border-b-2 border-red-500`
                          : "cursor-pointer"
                      }
                      onClick={() => setActiveFileTab("picture")}
                    >
                      Photo
                    </label>
                    <label
                      htmlFor=""
                      className={
                        activeFileTab === "video"
                          ? `border-b-2 border-red-500`
                          : "cursor-pointer"
                      }
                      onClick={() => setActiveFileTab("video")}
                    >
                      Twik video
                    </label>
                  </div>
                  {/* upload picture  */}
                  {activeFileTab === "picture" ? (
                    <>
                      <label htmlFor="postImage" className="w-full">
                        <div
                          className={
                            dark
                              ? "block w-full h-60 bg-gray-50 darkmode--file border rounded hover:bg-gray-100 cursor-pointer"
                              : "block w-full h-60 bg-gray-50 border rounded hover:bg-gray-100 cursor-pointer"
                          }
                        >
                          <div className="flex justify-center h-full items-center">
                            {!file ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="60"
                                height="60"
                              >
                                <path fill="none" d="M0 0h24v24H0z" />
                                <path
                                  d="M4.828 21l-.02.02-.021-.02H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H4.828zM20 15V5H4v14L14 9l6 6zm0 2.828l-6-6L6.828 19H20v-1.172zM8 11a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                                  fill="rgba(249,2,2,1)"
                                />
                              </svg>
                            ) : (
                              // eslint-disable-next-line jsx-a11y/img-redundant-alt
                              <img
                                src={file}
                                alt="Featured image"
                                className="create--featured-image object-contain"
                              />
                            )}
                          </div>
                        </div>
                      </label>
                      <input
                        type="file"
                        className="form-control post--image"
                        id="postImage"
                        onChange={uploadImage}
                        hidden
                      />
                    </>
                  ) : (
                    <>
                      <input
                        type="file"
                        className="form-control post--image"
                        onChange={uploadImage}
                      />
                    </>
                  )}
                </div>
              </>
            )}

            {/* files uploading done */}
            {!loading ? (
              <button className="mb-5 py-2 px-12 rounded bg-fire upda-btn text-white hover:opacity-50">
                Twik
              </button>
            ) : (
              <button
                className="mb-5 py-2 px-12 rounded bg-fire opacity-50 text-white flex gap-1 items-center"
                disabled
              >
                <LoadingOutlined />
                <span> Twikking ...</span>
              </button>
            )}
          </form>
        </div>
          </div>

        <div className="lg:col-span-5">{user.token ? <Logged /> : <TryLogin />}</div>
      </div>
    </div>
  );
};
export default CreatePost;